<template>
  <div>
    <div class="tw-text-gray-800 tw-flex">
      <money-format :value="event.amount" :locale="locale" subunits-value />
      &nbsp;{{ title }}
    </div>
    <div class="tw-text-gray-500 tw-text-xs">Customer reported: {{ event.label }}</div>
    <div class="tw-text-gray-500 tw-text-xs">Status: {{ computedStatus }}</div>
    <base-button class="tw-mt-1" type="text" size="xs" @click="linkStripe">Manage in Stripe</base-button>
  </div>
</template>

<script>
import MoneyFormat from "vue-money-format";
import { startCase } from "lodash";

export default {
  components: {
    MoneyFormat,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    locale() {
      return window.navigator.language;
    },
    title() {
      return startCase(this.event.type);
    },
    computedStatus() {
      return this.event.status.replace("warning_", "").replace("_", " ");
    },
  },
  methods: {
    linkStripe() {
      window.open("https://dashboard.stripe.com/charges/" + this.event.secondaryId, "_blank");
    },
  },
};
</script>
